module.exports = __webpack_public_path__ + "media/rede-seguradora.a2d36db7.png";